export const NOT_FOUND_ROUTE = '*' // docs - https://reactrouter.com/docs/en/v6/getting-started/overview#not-found-routes

export const DYNAMIC_ROUTE_START = ':'

export const CONCAT_ROUTE_DEPTH = 1

export const GO_BACK_DELTA = -1 // learn more - https://github.com/remix-run/react-router/blob/main/packages/react-router/lib/hooks.tsx#L125
